import React, { FunctionComponent } from 'react';
import i18next from 'i18next';

import Table from 'components/commons/Table';

import { ViewContainer, ViewContent } from 'styles/view';

import { IPersonsViewProps } from './types';

import './i18n';

const PersonsView: FunctionComponent<IPersonsViewProps> = (props: IPersonsViewProps) => {
  const { columns, count, data, loading, onAddClick, onTableUpdate, options, table } = props;

  return (
    <ViewContainer auth data-testid="persons-view">
      <ViewContent auth>
        <Table
          columns={columns}
          count={count}
          data={data}
          loading={loading}
          onAddClick={onAddClick}
          onTableUpdate={onTableUpdate}
          options={options}
          title={i18next.t<string>('PERSONS_VIEW:TITLE')}
          table={table}
        />
      </ViewContent>
    </ViewContainer>
  );
};

export default PersonsView;
